import React from 'react';
import BackgroundGrid from "../base-components/BackgroundGrid";

function Hero() {
    return (
        <section
            id="hero"
            aria-label="Hero section"
            className="
            relative bg-black items-center justify-center flex flex-col
            lg:px-6 lg:py-10 lg:min-h-[50vw] lg:items-start
            "
        >
            <BackgroundGrid
                gridSize="80px"
                gridColor="#8884ff"
                opacity={0.4}
                fadeOffset={0.2}
            />

            <div
                aria-hidden="true"
                className="
                    block mt-16 -mb-10
                    lg:hidden
                "
                style={{
                    WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
                    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
                    WebkitMaskSize: '100% 100%',
                    maskSize: '100% 100%',
                    WebkitMaskRepeat: 'no-repeat',
                    maskRepeat: 'no-repeat',
                }}
            >
                <img
                    src="/images/brain.webp"
                    alt="Artificial Intelligence"
                    className="w-full h-auto"
                />
            </div>

            <div className="
            flex flex-col justify-center items-center
            lg:flex-row lg:justify-start lg:mt-10
            ">
                <div className="
                relative flex flex-col text-center text-light max-w-[85%] mb-16
                md:-mt-14
                lg:z-20 lg:text-left lg:max-w-[60%] lg:mt-16
                xl:mt-0
                2xl:gap-y-16
                ">
                    <h2 className="
                        text-4xl font-[900]
                        md:text-6xl
                        lg:text-[6vw]
                    ">
                        INTELLIGENZA<br/>ARTIFICIALE<br/>SU MISURA
                    </h2>
                    <p className="
                        font-[400] mt-4
                        md:text-3xl
                        lg:text-[3vw]
                        2xl:leading-[3.5vw]
                    ">
                        Soluzioni concrete di deep learning
                        per lo sport, i mercati e l'industria.
                    </p>
                </div>
                <div className="
                        hidden
                        lg:block
                "
                >
                    <img src="/images/brain.webp" alt="Cervello AI"/>
                </div>
            </div>
        </section>
    );
}

export default Hero;
